import { useRouter } from 'next/router';
import { useState, useEffect, useCallback } from 'react';

import ProductNav from '../../../common/ProductNav';
import { tabsValues } from '../../../config/pageConfig';

import FirstKV from '../components/JP/FirstKV';
import SectionA from '../components/JP/SectionA';
import SectionB from '../components/JP/SectionB';
import SectionC from '../components/JP/SectionC';
import SectionD from '../components/JP/SectionD';
import SectionE from '../components/JP/SectionE';
import SectionF from '../components/JP/SectionF';
import SectionG from '../components/JP/SectionG';
import SectionH from '../components/JP/SectionH';
import SectionI from '../components/JP/SectionI';

export default function StatusItem() {
    const { locale = 'us', query } = useRouter();

    const searchTab = query?.tab;
    let defaultTab = 'Product';
    if (typeof searchTab === 'string' && tabsValues.includes(searchTab)) {
        defaultTab = searchTab;
    }
    const [activeTab, setActiveTab] = useState(defaultTab);

    return (
        <>
            <ProductNav activeTab={activeTab} />
            {activeTab === 'Product' && (
                <>
                    {locale === 'jp' && (
                        <>
                            <FirstKV />
                            <SectionA />
                            <SectionB />
                            <SectionC />
                            <SectionD />
                            <SectionE />
                            <SectionG />
                            <SectionF />
                            <SectionH />
                            <SectionI />
                        </>
                    )}
                </>
            )}
        </>
    );
}
